import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import Dropdown from '@ecp/common/src/components/dropdown/mo/Dropdown';

import GoodCtaButtonOptionItem from '@mo-pages/good/components/cta/option/GoodCtaButtonOptionItem';

const SubGoodOptionItem = ({ itemList, subGoodIndex, soldOut, stopSale, ...props }) => {
  const leafItem = useMemo(
    () => (itemList[0]?.itemNumber === '00000' ? { ...itemList[0], soldOut, stopSale } : undefined),
    [itemList, soldOut, stopSale]
  );

  return <GoodCtaButtonOptionItem leafItem={leafItem} subGoodIndex={subGoodIndex} {...props} />;
};

SubGoodOptionItem.propTypes = {
  label: PropTypes.string,
  subGoodIndex: PropTypes.string,
  itemList: PropTypes.array,
  soldOut: PropTypes.bool,
  stopSale: PropTypes.bool,
};

const GoodCtaButtonGroupItemList = ({ subGoodItemList, subGoodDetail, onSelect }) => (
  <FlexBox width={'100%'}>
    <Dropdown
      placeholder={'상품을 선택해 주세요'}
      items={subGoodItemList}
      value={subGoodDetail}
      onChange={onSelect}
      itemSlot={SubGoodOptionItem}
    />
  </FlexBox>
);

GoodCtaButtonGroupItemList.propTypes = {
  floatingType: PropTypes.bool,
  subGoodItemList: PropTypes.array,
  subGoodDetail: PropTypes.object,
  onSelect: PropTypes.func,
};

export default GoodCtaButtonGroupItemList;
